import {isTabletOrMobile} from '@zzng/common/utils/agent';

export const attachAgentClassName = () => {
  const body = document.querySelector('body');
  /** body 클래스 초기화 */
  body?.classList.remove('mo', 'pc');
  const agentClassName = isTabletOrMobile ? 'mo' : 'pc';
  body?.classList.add(agentClassName);
};
